import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import classNames from 'classnames'

import {
  CContainer,
  CForm,
  CFormInput,
  CHeader,
  CHeaderBrand,
  CHeaderNav,
  CHeaderToggler,
  CInputGroup,
  CInputGroupText,
  CRow,
  CCol,
  CNavLink,
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import {
  cilApplicationsSettings,
  cilMenu,
  cilSearch,
  cilList,
  cilApplications,
  cilSettings,
  cilDollar,
} from '@coreui/icons'

import {
  AppHeaderDropdown,
  AppHeaderDropdownMssg,
  AppHeaderDropdownNotif,
  AppHeaderDropdownTasks,
} from './header/index'

// import { logoNegative } from 'src/assets/brand/logo-negative'
// import { logoNegative } from 'src/assets/brand/logo-negative-salescube'
import * as cusUtil from 'src/viewsCommon/CusUtil'
import * as cusUrlUtil from 'src/viewsCommon/CusUrlUtil'
// import U_UserDetailModal from '../viewsCus/user/U_UserDetailModal'

const AppHeader = (param) => {
  const dispatch = useDispatch()

  const theme = useSelector((state) => state.theme)

  theme === 'dark'
    ? document.body.classList.add('dark-theme')
    : document.body.classList.remove('dark-theme')

  const sidebarShow = useSelector((state) => state.sidebarShow)
  const asideShow = useSelector((state) => state.asideShow)
  // const userName = '안녕하세요 ' + cusUtil.getJwtToken().sub + '님'

  // 좌측메뉴 여부
  var sideMenuView = 'y'
  if (param.layout == 'user') {
    if (cusUtil.getCid() == 'pwan') {
      sideMenuView = 'y'
    } else {
      sideMenuView = 'n'
    }
  }

  const navigate = useNavigate()

  const handleLogout = (event) => {
    cusUtil
      .axiosGet('/cube_dev_local/api/logout')
      .then((response) => {
        console.log(response)
      })
      .catch((error) => {
        console.log(error.response)
      })
      .finally(() => {
        cusUtil.setCookie('jwttoken', '', 0)
        cusUtil.setCookie('jwttokenRe', '', 0)
        navigate('/login')
      })
  }

  const handleLogoClick = (event) => {
    navigate('/commonMenu/MenuDashboardUser')
  }

  return (
    <CHeader position="sticky" className={param.margin !== 'n' ? 'mb-4' : undefined}>
      <CContainer fluid>
        {sideMenuView !== 'n' && (
          <CHeaderToggler
            className={classNames('px-md-0 me-md-3 d-lg-none', {
              'prevent-hide': !sidebarShow,
            })}
            onClick={() => dispatch({ type: 'set', sidebarShow: !sidebarShow })}
          >
            <CIcon icon={cilMenu} size="lg" />
          </CHeaderToggler>
        )}

        {/* <CHeaderBrand className="mx-auto d-md-none" to="/"> */}
        <CHeaderBrand className="d-md-none" href="/">
          {/* <CIcon icon={logoNegative} height={34} alt="Logo" /> */}
          {cusUrlUtil.getCidData()['REACT_APP_LOGO_IMAGE_YN'] === 'n' && (
            <div className="fs-5 fw-semibold" onClick={handleLogoClick}>
              {cusUrlUtil.getCidData()['REACT_APP_LOGO_IMAGE_TITLE']}
            </div>
          )}
          {cusUrlUtil.getCidData()['REACT_APP_LOGO_IMAGE_YN'] === 'y' && (
            <img
              className="d-block mw-200px mh-35px"
              src={cusUrlUtil.getCidData()['REACT_APP_LOGO_IMAGE_SVG']}
              alt="slide 1"
            />
          )}
        </CHeaderBrand>
        {/* <CForm className="d-none d-md-flex">
          <CInputGroup>
            <CInputGroupText id="search-addon" className="bg-light border-0 px-1">
              <CIcon icon={cilSearch} size="lg" className="my-1 mx-2 text-disabled" />
            </CInputGroupText>
            <CFormInput
              placeholder="Search..."
              aria-label="Search"
              aria-describedby="search-addon"
              className="bg-light border-0"
            />
          </CInputGroup>
        </CForm> */}
        {/* <CHeaderNav className="d-none d-sm-flex ms-auto me-3">
          <AppHeaderDropdownNotif />
          <AppHeaderDropdownTasks />
          <AppHeaderDropdownMssg />
        </CHeaderNav> */}
        {/* <CHeaderNav className="ms-auto ms-sm-0 me-sm-4">
          <AppHeaderDropdown />
        </CHeaderNav> */}
        {/* <CHeaderNav className="ms-2 me-2">
          <CRow>
            <CCol>
              <span className="me-3">
                <CIcon icon={cilSettings} size="sm" className="me-1" />
                설정
              </span>
              <span className="me-2">
                <CIcon icon={cilApplications} size="sm" className="me-1" />
                서비스
              </span>
              <span className="me-3">
                <CIcon icon={cilDollar} size="sm" className="me-1" />
                정산
              </span>
            </CCol>
          </CRow>
        </CHeaderNav> */}
        {/* 설정 서비스 정산 */}
        {/* <CHeaderNav className="d-none d-sm-flex ms-auto"> */}
        <CHeaderNav className="d-sm-flex ms-auto">
          <AppHeaderDropdown />
        </CHeaderNav>
        <CHeaderNav className="me-0">
          {/* <CNavLink href="/login#/login">로그인</CNavLink> */}
          {/* <CNavLink>안녕하세요 {userName} 님</CNavLink> */}
          {/* <U_UserDetailModal title={userName} /> */}
          {/* <CNavLink href="#" onClick={handleLogout}>
            [로그아웃]
          </CNavLink> */}
        </CHeaderNav>
        {/* <CHeaderToggler
          className="px-md-0 me-md-3"
          onClick={() => dispatch({ type: 'set', asideShow: !asideShow })}
        >
          <CIcon icon={cilApplicationsSettings} size="lg" />
        </CHeaderToggler> */}
      </CContainer>
    </CHeader>
  )
}

export default AppHeader
